import { AbstractProgramModel } from "@app/catalog-common";

export class ProgramAddedMessage {
    public program: AbstractProgramModel;
    
    constructor(program: AbstractProgramModel)
    {
        this.program = program;
    }
}